import { Observable } from "rxjs";
import { InjectionKey } from "vue";

export type gotoIndex = () => void;
export const gotoIndexInjectKey = Symbol() as InjectionKey<gotoIndex>;
export type forceLogin = () => Promise<void>;
export const forceLoginInjectKey = Symbol() as InjectionKey<forceLogin>;
export type submit = (triggerKey: string | null, event: Event) => Promise<void>;
export const submitInjectKey = Symbol() as InjectionKey<submit>;
export type deleteDraft = (asAdmin: boolean, event: Event) => Promise<void>;
export const deleteDraftInjectKey = Symbol() as InjectionKey<deleteDraft>;
export type pageStatusFetcher = () => Record<string, string>;
export const pageStatusFetcherInjectKey = Symbol() as InjectionKey<pageStatusFetcher>;
export type resendEmail = (segment: string, commentRequired: boolean, eventType: string, type: string) => Promise<void>;
export const resendEmailInjectKey = Symbol() as InjectionKey<resendEmail>;
export type loading = (title: string, loadingPromise: Promise<void[]>) => void;
export const loadingInjectKey = Symbol() as InjectionKey<loading>;
export type submitButtons$ = Observable<{ text: string | null; trigger: string | null; order?: number }[]>;
export const submitButtons$InjectKey = Symbol() as InjectionKey<submitButtons$>;
